import React, { useState } from "react";

interface ConfirmButtonProps {
    label: string;
    onClick: () => void;
    [key: string]: any;
}

const ConfirmButton = ({ label, onClick, ...rest }: ConfirmButtonProps) => {
    const [confirm, setConfirm] = useState(false);

    const handleClick = () => {
        if (confirm) {
            onClick();
            setConfirm(false);
        } else {
            setConfirm(true);
        }
    };

    const handleBlur = () => {
        setConfirm(false);
    };

    return (
        <button
            className={`px-4 py-2 rounded-md font-normal transition-colors ${
                confirm
                    ? "bg-brand text-white hover:bg-brand-dark"
                    : "bg-background-front text-text hover:bg-background-back border border-border"
            }`}
            onClick={handleClick}
            onBlur={handleBlur}
            {...rest}
        >
            {confirm ? `Confirm ${label}` : label}
        </button>
    );
};

export default ConfirmButton;
